import { Sha256 as BrowserSha256 } from "@aws-crypto/sha256-browser";
import { convertToBuffer } from "@aws-crypto/util";
import { NodeHash } from './node_hash';
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if (supportsCryptoModule()) {
            this.hash = new NodeHash("sha256", secret);
        }
        else {
            this.hash = new BrowserSha256(secret);
        }
    }
    Sha256.prototype.update = function (data, encoding) {
        this.hash.update(convertToBuffer(data));
    };
    Sha256.prototype.digest = function () {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function () {
        this.hash.reset();
    };
    return Sha256;
}());
export { Sha256 };
function supportsCryptoModule() {
    try {
        return !!require("crypto").createHash;
    }
    catch (_a) {
        return false;
    }
}
//# sourceMappingURL=index.js.map